import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-b2ab926c"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  key: 1,
  class: "page-container"
};
var _hoisted_2 = {
  class: "nav-header-box"
};
var _hoisted_3 = {
  class: "page-inner-container"
};
var _hoisted_4 = {
  class: "contest-list-box"
};
var _hoisted_5 = {
  class: "page-inner-container"
};
var _hoisted_6 = {
  class: "pagination-box"
};
var _hoisted_7 = {
  class: "page-inner-container"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_a_empty = _resolveComponent("a-empty");
  var _component_Banner = _resolveComponent("Banner");
  var _component_NavHeader = _resolveComponent("NavHeader");
  var _component_ContestCard = _resolveComponent("ContestCard");
  var _component_a_pagination = _resolveComponent("a-pagination");
  return _ctx.activityService && _ctx.activityService.isActivityList && _ctx.activityService.activityTypeList && _ctx.activityService.activityTypeList.length === 0 ? (_openBlock(), _createBlock(_component_a_empty, {
    key: 0,
    description: "活动筹备中",
    style: {
      "padding": "200px 0 400px",
      "font-size": "14px",
      "color": "#8f96a3"
    },
    image: _ctx.emptyImage,
    imageStyle: {
      height: '185px'
    }
  }, null, 8, ["image"])) : _ctx.activityService ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_Banner, {
    height: 360,
    title: "",
    image: _ctx.activityService.bannerImage
  }, null, 8, ["image"]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_ctx.activityService.activityTypeList && _ctx.activityService.activityTypeList.length ? (_openBlock(), _createBlock(_component_NavHeader, {
    key: 0,
    list: _ctx.activityService.activityTypeList,
    onChange: _ctx.onActivityTypeChange
  }, null, 8, ["list", "onChange"])) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_ctx.activityService.activityList && _ctx.activityService.activityList.length ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 0
  }, _renderList(_ctx.activityService.activityList, function (item) {
    return _openBlock(), _createBlock(_component_ContestCard, {
      key: "".concat(item.contestId, "-").concat(item.cityId),
      data: item,
      onClick: function ($event) {
        return _ctx.onContestCardClick(item);
      }
    }, null, 8, ["data", "onClick"]);
  }), 128)) : _ctx.activityService.total >= 0 ? (_openBlock(), _createBlock(_component_a_empty, {
    key: "key-empty",
    description: "活动筹备中",
    style: {
      "padding": "60px 0 120px",
      "font-size": "14px",
      "color": "#8f96a3"
    },
    image: _ctx.emptyImage,
    imageStyle: {
      height: '185px'
    }
  }, null, 8, ["image"])) : _createCommentVNode("", true)])]), _withDirectives(_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createVNode(_component_a_pagination, {
    "show-size-changer": "",
    current: _ctx.activityService.pageNum,
    "onUpdate:current": _cache[0] || (_cache[0] = function ($event) {
      return _ctx.activityService.pageNum = $event;
    }),
    pageSize: _ctx.activityService.pageSize,
    "onUpdate:pageSize": _cache[1] || (_cache[1] = function ($event) {
      return _ctx.activityService.pageSize = $event;
    }),
    total: _ctx.activityService.total,
    pageSizeOptions: ['6', '12', '16', '20', '24', '28', '32'],
    onChange: _ctx.onPageNumChange,
    onShowSizeChange: _ctx.onShowSizeChange
  }, null, 8, ["current", "pageSize", "total", "onChange", "onShowSizeChange"])])], 512), [[_vShow, _ctx.activityService.total > 0]])])) : _createCommentVNode("", true);
}